import { googleReverseGeocode } from '../util/addressService';

export class UseMyLocationSearch {
    constructor(){
        const useLocationButton = document.querySelector('.modal-search .use-my-location-btn');
        const useLocationButtonHms = document.querySelector('.location-search-form .use-my-location-btn'); 
        if(useLocationButton){
            useLocationButton.addEventListener('click', this.getCurrentLocation.bind(this))
        }
        if(useLocationButtonHms){
            useLocationButtonHms?.addEventListener('click', this.getCurrentLocation.bind(this))
        }
    }
    async getCurrentLocation(event:any,inputElement?:HTMLInputElement){ 
        event?.stopPropagation();
        event?.preventDefault();
        // Find the closest input in the same form as the clicked button
        let input: HTMLInputElement | null = null;
        if (event?.currentTarget) {
            const button = event.currentTarget as HTMLElement;
            const form = button?.closest('form');
            if (form) {
                input = form.querySelector('input[type="search"], input[type="text"]');
            }
        }

        // If an inputElement is provided, use it instead
        if (inputElement) {
            input = inputElement;
        }

        if (navigator.geolocation && input) {
            navigator.geolocation.getCurrentPosition(function(e) {
                let LatValue = e.coords.latitude;
                let LngValue = e.coords.longitude;
                getZipFromLatLng(LatValue, LngValue, input);
            });

            async function getZipFromLatLng(LatValue: any, LngValue: any, targetInput: HTMLInputElement) {
                if (LatValue === '' || LngValue === '') { return };
                let ZipCodeValue: any;
                // Migrated from HERE revgeocode.search.hereapi.com to Google's Geocoding
                // API via the shared addressService adapter, which returns the same
                // HERE-shaped { items: [{ address: { postalCode, ... } }] } contract.
                const response = await googleReverseGeocode(LatValue, LngValue);
                if (!response) {
                    console.log("Geolocation is not available in this browser.");
                    return;
                }
                let results = response?.items;
                if (Array.isArray(results) && results?.length > 0 && results[0]?.address) {
                    for (let key in results[0]?.address) {
                        if (key.indexOf('postalCode') > -1 && results[0].address[key]) {
                            ZipCodeValue = results[0].address.postalCode;
                        }
                    }
                }
                if (ZipCodeValue) {
                    if (ZipCodeValue.includes('-')) {
                        ZipCodeValue = ZipCodeValue.split('-')[0];
                    }
                    targetInput.value = ZipCodeValue;
                }
            }
        }
    }
}

const useMyLocation = new UseMyLocationSearch();

